__turbopack_context__.v({
  "combobox": "XHOuYq_combobox",
  "comboboxInput": "XHOuYq_comboboxInput",
  "comboboxList": "XHOuYq_comboboxList",
  "comboboxOption": "XHOuYq_comboboxOption",
  "comboboxPopover": "XHOuYq_comboboxPopover",
  "iconEnd": "XHOuYq_iconEnd",
  "iconStart": "XHOuYq_iconStart",
  "inputIcon": "XHOuYq_inputIcon",
  "inputIconEnd": "XHOuYq_inputIconEnd",
  "inputIconStart": "XHOuYq_inputIconStart",
  "inputWrapper": "XHOuYq_inputWrapper",
});
